// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2efFO","inner":"Footer_inner__2x7q5","nextIcon":"Footer_nextIcon__1z3B-","innerLeft":"Footer_innerLeft__2gbmC"};